import "../assets/css/Dashboard.css";
import { Typography } from "@mui/material";

import DashboardHeader from "../components/DashboardHeader";
import Embeded from "../components/Embeded";
import CustomDashboard from "../components/CustomDashboard";

import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { useData } from "../contexts/DataContext";

import { customDashboards } from "../dashboards";
import { findDashboardById } from "../utils/findDashboardById";
import { DashboardInfo } from "../utils/types";
import { DashboardFilterProvider } from "../contexts/DashboardFilterContext";

interface IDashboardProps {
  isEmbedded?: boolean;
}

export default function Dashboard({
  isEmbedded = false,
}: Readonly<IDashboardProps>) {
  const params = useParams();
  const navigate = useNavigate();
  const id: number | undefined = params.id
    ? Number.parseInt(params.id, 10)
    : undefined;

  const { dashboardList } = useData();

  const [dashboardInfo, setDashboardInfo] = useState<DashboardInfo | null>(
    null,
  );

  useEffect(() => {
    if (!id || dashboardList.length === 0) return;

    const dbInfo = findDashboardById(dashboardList, id);

    if (!dbInfo) {
      setDashboardInfo(null);
      if (!isEmbedded) {
        navigate("/", { replace: true });
      }
      return;
    }
    setDashboardInfo(dbInfo);
  }, [id, dashboardList, isEmbedded, navigate]);

  useEffect(() => {
    if (!document.referrer) return;
    const height = document.documentElement.scrollHeight;
    const parentOrigin = new URL(document.referrer).origin;
    window.parent.postMessage({ type: "resize", height }, parentOrigin);
  }, []);

  const customDashboard =
    id && dashboardInfo && customDashboards[id] ? customDashboards[id] : null;

  let dashboardContent: React.ReactNode = null;
  if (customDashboard) {
    if (customDashboard.Component) {
      dashboardContent = <customDashboard.Component dashboardId={id} />;
    } else {
      dashboardContent = (
        <DashboardFilterProvider filters={customDashboard.filters}>
          <CustomDashboard id={id!} hideTitle />
        </DashboardFilterProvider>
      );
    }
  } else if (dashboardInfo?.dashboard_uuid) {
    dashboardContent = <Embeded dashboardInfo={dashboardInfo} />;
  } else {
    dashboardContent = <Typography></Typography>;
  }

  return (
    <>
      {!isEmbedded && (
        <DashboardHeader
          dashboardInfo={dashboardInfo}
          hideBreadcrumbs={isEmbedded}
          hideSectionMenu={isEmbedded}
        />
      )}
  {id !== undefined && dashboardContent}
    </>
  );
}
